import EmployeeSummary from './EmployeeSummary';

export default EmployeeSummary;
